const getOverriddenItems = (state: AnyFixMe) =>
  state.leftTree.overridden.overriddenItems;
const getOverriddenVisibility = (state: AnyFixMe) =>
  state.leftTree.overridden.shouldShow;

export { getOverriddenItems, getOverriddenVisibility };
